import React from 'react';
import {MenuItem} from '@material-ui/core';

export default function mapRowsToOptions(item: any) {
    return (
        <MenuItem
            key={item}
            value={item}
        >
            {item}
        </MenuItem>
    );
}
